module.exports = __webpack_public_path__ + "media/assets/images/blog/default_image-3fbae600a57a12157c049fd8f30fdac5.jpg";